function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, nft_overlay) {
  var _app$browser;
  var allSlips = nft_overlay.nft.returnAllSlips() || [];
  var availableAmount = 0n;
  var _iterator = _createForOfIteratorHelper(allSlips),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      try {
        var _slip$slip;
        availableAmount += BigInt((slip === null || slip === void 0 || (_slip$slip = slip.slip1) === null || _slip$slip === void 0 ? void 0 : _slip$slip.amount) || 0);
      } catch (err) {
        var _slip$slip2;
        console.warn('Invalid NFT amount in transfer form:', slip === null || slip === void 0 || (_slip$slip2 = slip.slip1) === null || _slip$slip2 === void 0 ? void 0 : _slip$slip2.amount);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var availableDisplay = availableAmount.toString();
  if ((_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.formatLocaleAmount) {
    availableDisplay = app.browser.formatLocaleAmount(availableAmount.toString(), {
      maxFractionDigits: 0,
      strictLocaleSeparators: false
    });
  }
  var html = "\n    <div class=\"saito-nft-panel saito-nft-panel-send\">\n      <div class=\"saito-nft-panel-body\">\n        <section id='transfer-info-panel'>\n          <h2 class=\"saito-nft-mode-title\">Send NFT</h2>\n          <label class=\"saito-nft-input-label\" for=\"nft-receiver-address\">Recipient Address</label>\n          <div class=\"nft-send-input-row nft-recipient-input-row\">\n            <input\n              type=\"text\"\n              autocomplete=\"off\"\n              spellcheck=\"false\"\n              class=\"saito-input\"\n              id=\"nft-receiver-address\"\n              aria-describedby=\"nft-recipient-status\"\n              required\n            />\n            <div class=\"nft-send-input-actions\">\n              <button type=\"button\" class=\"saito-icon-button\" id=\"nft-paste-address\" title=\"Paste address\" aria-label=\"Paste recipient address\">\n                <i class=\"fa-solid fa-paste\" aria-hidden=\"true\"></i>\n              </button>\n              <button type=\"button\" class=\"saito-icon-button\" id=\"nft-scan-address\" title=\"Scan QR code\" aria-label=\"Scan recipient QR code\">\n                <i class=\"fa-solid fa-qrcode\" aria-hidden=\"true\"></i>\n              </button>\n              <button type=\"button\" class=\"saito-icon-button\" id=\"nft-address-book\" title=\"Contacts\" aria-label=\"Open contacts\">\n                <i class=\"fa-solid fa-users\" aria-hidden=\"true\"></i>\n              </button>\n            </div>\n          </div>\n          <div class=\"nft-recipient-preview hide-element\" id=\"nft-recipient-status\" aria-live=\"polite\"></div>\n          <div class=\"nft-send-label-row\">\n            <label class=\"saito-nft-input-label\" for=\"nft-send-amount\">Amount</label>\n            <span class=\"nft-send-balance\">Balance: <strong id=\"nft-send-balance\">".concat(availableDisplay, "</strong></span>\n          </div>\n          <div class=\"nft-send-amount-row\">\n            <input\n              type=\"text\"\n              autocomplete=\"off\"\n              inputmode=\"numeric\"\n              pattern=\"[0-9]*\"\n              class=\"saito-input\"\n              id=\"nft-send-amount\"\n              value=\"\"\n              required\n            />\n            <div class=\"nft-send-amount-actions\">\n              <button type=\"button\" class=\"nft-send-max-btn\" title=\"Use maximum amount\">MAX</button>\n              <span\n                class=\"nft-amount-status hide-element\"\n                id=\"nft-amount-status\"\n                role=\"status\"\n                aria-label=\"\"\n                tabindex=\"-1\"\n              >\n                <i class=\"fa-solid fa-check\" aria-hidden=\"true\"></i>\n              </span>\n            </div>\n            <div class=\"nft-amount-tooltip\" id=\"nft-amount-tooltip\" role=\"tooltip\"></div>\n          </div>\n        </section>\n  ");
  var splitUtxosHtml = '';
  var utxoIdx = 0;
  var _iterator2 = _createForOfIteratorHelper(allSlips),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _slip = _step2.value;
      utxoIdx++;
      var uuid = 'N/A';
      if (_slip.slip1) {
        var blockId = _slip.slip1.block_id || 'N/A';
        var txOrdinal = _slip.slip1.tx_ordinal || 'N/A';
        var slipIndex = _slip.slip1.slip_index !== undefined ? _slip.slip1.slip_index : 'N/A';
        uuid = "".concat(blockId, "-").concat(txOrdinal, "-").concat(slipIndex);
      }
      splitUtxosHtml += "\n        <div class=\"".concat(utxoIdx == 1 ? 'selected-shard' : '', " nft-slip-box utxo-").concat(utxoIdx, "\" data-utxo-idx=\"").concat(utxoIdx, "\">\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">UUID:</div>\n            <div class=\"nft-slip-box-value\">").concat(uuid, "</div>\n          </div>\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">amount:</div>\n            <div class=\"nft-slip-box-value\">").concat(_slip.slip1.amount, "</div>\n          </div>\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">deposit:</div>\n            <div class=\"nft-slip-box-value\">").concat(app.wallet.convertNolanToSaito(_slip.slip2.amount), " SAITO</div>\n          </div>\n        </div>\n      ");
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  html += "\n        <div class=\"nft-advanced-options collapsed\">\n          <button type=\"button\" class=\"nft-advanced-toggle\" aria-expanded=\"false\">\n            <i class=\"fa-solid fa-caret-right nft-advanced-caret\"></i>\n            <span>Advanced Options</span>\n          </button>\n          <div class=\"nft-advanced-content\">\n            <div class=\"nft-slips-container\">\n              <div class=\"nft-slips-title\">AVAILABLE SHARDS</div>\n              <div class=\"nft-slips-flex\">\n                ".concat(splitUtxosHtml, "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      \n      <footer class=\"saito-nft-panel-footer\">\n        <button type=\"button\" class=\"saito-button-square saito-nft-send-back\" aria-label=\"Back\">\n          <i class=\"fa-solid fa-arrow-left\" aria-hidden=\"true\"></i>\n        </button>\n        <span class=\"saito-nft-footer-spacer\"></span>\n        <button type=\"button\" class=\"saito-button-primary saito-nft-footer-btn saito-nft-confirm-btn\" disabled>Send</button>\n      </footer>\n    </div>\n    ");
  return html;
};